import { DefaultWasteAmountUnit } from "./DefaultWasteAmountUnit";

export const WasteAmountUnits = [DefaultWasteAmountUnit, "kg"];
